import { FC } from 'react';

import { Feature } from '@telialt/models/src/EshopModel';

type Props = {
    isLast: boolean;
    feature: Feature;
};

export const CharacteristicsFeatureValueSeparator: FC<Props> = ({ isLast, feature }) => {
    return (
        <>
            {feature.range ? (
                (!isLast && '-') || feature.featureUnit?.symbol
            ) : (
                <>
                    {feature.featureUnit?.symbol}
                    {!isLast && <br aria-hidden={true} />}
                </>
            )}
        </>
    );
};
